import { useLanguage } from "../i18n/Language";
import React from 'react';

const Location = () => {
  const { t } = useLanguage();
  return (
    <section id="location" className="py-12 md:py-16 px-6 md:px-8 bg-light-bg">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl text-secondary mb-4 font-bold">{t("Visit Dr. Bharat Reddy Katta in L.B. Nagar")}

        </h2>
        <p className="text-lg md:text-xl text-text-color mb-8 opacity-80">{t("Consultation location and directions")}

        </p>
        <address className="not-italic text-lg leading-relaxed mb-6">{t("Srikara Hospital")}
          <br />{t("Plot No. 50, Nagarjuna Sagar Ring Road, opposite The New Green Bawarchi,")}
          <br />{t("Sri Durga Enclave, SBH Colony, L.B. Nagar, Hyderabad, Telangana 500074")}

        </address>
        <p className="mb-6">{t("Call ")}<a className="underline" href="tel:+917893107890">+91 78931 07890</a>{t(" to confirm consultation timings before your visit.")}</p>
        <div className="mt-6">
          <a
            href="https://www.google.com/maps?cid=4149802528954833232"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 bg-primary text-white no-underline rounded-lg font-semibold text-lg transition-all duration-300 shadow-md hover:bg-secondary hover:-translate-y-0.5 hover:shadow-lg">

            <i className="fas fa-map-marker-alt text-xl"></i>{t("Open in Google Maps")}

          </a>
        </div>
      </div>
    </section>);

};

export default Location;
